import { PluralizePipe } from '../../shared/pipes/pluralize.pipe';

export function pluralize ( pluralizePipe : PluralizePipe ) {
  return ( value : string ) : string => pluralizePipe.transform(value);
};
